/*
  Favoritos — lógica compartida por el corazón de la cabecera, el de las
  tarjetas de producto y la página /pages/favorites.

  POR QUÉ UN MÓDULO Y NO CÓDIGO EN CADA SITIO: cuando esto se escribió ya
  había DOS implementaciones sueltas del mismo corazón, una en la home
  móvil y otra en la ficha de producto, cada una con su propio try/catch
  y su propio formato. Una tercera y una cuarta copia habrían garantizado
  que un día dejaran de coincidir.

  FORMATO: 'lua:wishlist' es un array JSON de identificadores de producto
  en texto. NO se puede cambiar. sections/lua-best-sellers.liquid escribe
  ahí y es uno de los seis archivos congelados de la home móvil, así que
  cualquier formato nuevo dejaría fuera lo que el cliente guardó desde la
  portada.

  CONVIVENCIA CON ESE CÓDIGO CONGELADO: los botones de aquí se marcan con
  `data-lua-wish` y los suyos con `data-wish`. Son selectores distintos a
  propósito: si compartieran atributo, en la home móvil se ejecutarían los
  dos manejadores sobre el mismo clic y el segundo desharía al primero.
  Lo que sí se hace es repintar el contador después de un clic ajeno, para
  que la cabecera no se quede desfasada.
*/

const KEY = 'lua:wishlist';

function read() {
  try {
    const value = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(value) ? value.map(String) : [];
  } catch (error) {
    // Modo privado o almacenamiento lleno: se sigue sin favoritos.
    return [];
  }
}

function write(ids) {
  try {
    localStorage.setItem(KEY, JSON.stringify(ids));
  } catch (error) {
    // El estado visual ya ha cambiado; no guardarlo no debe romper nada.
  }
  document.dispatchEvent(new CustomEvent('lua:wishlist:change', { detail: { ids } }));
}

function has(id) {
  return read().includes(String(id));
}

function toggle(id) {
  const key = String(id);
  const current = read();
  const next = current.includes(key) ? current.filter((item) => item !== key) : current.concat(key);
  write(next);
  return next.includes(key);
}

/* Deja botones y contadores al día con lo que hay guardado. */
function paint() {
  const ids = read();

  document.querySelectorAll('[data-lua-wish]').forEach((button) => {
    button.setAttribute('aria-pressed', String(ids.includes(button.dataset.luaWish)));
  });

  document.querySelectorAll('[data-lua-wish-count]').forEach((element) => {
    element.textContent = ids.length > 99 ? '99+' : String(ids.length);
    element.toggleAttribute('hidden', ids.length === 0);
  });
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-lua-wish]');

  if (!button) {
    /*
      Clic en un corazón de los antiguos. No se toca —su propio código ya
      lo gestiona— pero el contador de la cabecera sí tiene que enterarse,
      y sólo puede leerse DESPUÉS de que aquel manejador haya escrito.
    */
    if (event.target.closest('[data-wish]')) setTimeout(paint, 0);
    return;
  }

  /*
    Imprescindible: en las rejillas la tarjeta entera es un enlace al
    producto, así que sin esto guardar un favorito navegaría fuera.
  */
  event.preventDefault();
  event.stopPropagation();

  const saved = toggle(button.dataset.luaWish);
  button.setAttribute('aria-pressed', String(saved));

  // Reinicia la animación aunque se pulse dos veces seguidas.
  button.classList.remove('is-pop');
  void button.offsetWidth;
  if (saved) button.classList.add('is-pop');
});

document.addEventListener('lua:wishlist:change', paint);

// Otra pestaña del mismo navegador.
window.addEventListener('storage', (event) => {
  if (event.key === KEY) paint();
});

// Rejillas que llegan por la API de secciones (filtros, paginación).
document.addEventListener('shopify:section:load', paint);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', paint);
} else {
  paint();
}

window.LuaWishlist = { KEY, read, has, toggle, paint };
